<template>
    <div class="submission-process">
        <h1 class="submission-process__title">A/S접수 방법 안내</h1>
        <div class="submission-nav">
            <ul class="submission-nav__lists">
                <li :class="{ 'submission-nav__list--on': isNav === 1 }" class="submission-nav__list"><a class="link" href="#" @click="activeNav(1)">고객님께서 직접 제품을발송하실 경우</a></li>
                <li :class="{ 'submission-nav__list--on': isNav === 2 }" class="submission-nav__list"><a class="link" href="#" @click="activeNav(2)">구매점 혹은 가까운 취급점에 방문하여 위탁하시는 경우</a></li>
            </ul>
        </div>
        <ol class="submission-process__lists">
            <li v-for="(process, i) in processes" :key="`process-${i}`"
                class="submission-process__list">
                <div class="submission-process__box">
                    <em class="submission-process__badge">STEP {{ i + 1 }}</em>
                    <span class="submission-process__image" v-html="process.img"></span>
                    <h2 class="submission-process__name">{{ process.title }}</h2>
                    <p v-html="process.desc"></p>
                </div>
            </li>
        </ol>
        <div v-if="isNav === 1" class="box-style box-style--line">
            <h3 class="box-style--line__tit"><small>■ </small>택배발송 주소</h3>
            <p class="box-style--line__txt">경기도 부천시 삼작로144번길 22 (내동) (주)제이에스컴퍼니</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isNav: 1,
            processes: [
                { title: "접수증 작성", desc: "A/S접수 페이지를 통해 A/S를 접수해주세요.", img: "<img src='/images/sub/inquiry/step-1-1.png'>" },
                { title: "택배발송", desc: "부러진 낚싯대 / 보증서 / 접수번호 동봉하여 제이에스컴퍼니로 택배 발송해주세요. <span class='color-red'>(선불)</span>", img: "<img src='/images/sub/inquiry/step-2-1.png'>" },
                { title: "A/S등록", desc: "A/S부서에서 택배 수령 후접수 완료 시 A/S접수 페이지에서 확인 가능합니다. 접수 완료 시 카카오 알림톡 혹은 문자로 안내 발송 드립니다.", img: "<img src='/images/sub/inquiry/step-3.png'>" },
                { title: "A/S완료 택배발송", desc: "택배 발송 시 카카오 알림톡 혹은 문자로 안내 발송 드립니다.", img: "<img src='/images/sub/inquiry/step-4.png'>" },
            ],
        };
    },
    methods: {
        activeNav(nav){
            event.preventDefault();
            this.isNav = nav;
            if(nav === 1){
                this.processes[0].title = "접수증 작성";
                this.processes[0].desc = "A/S접수 페이지를 통해 A/S를 접수해주세요.";
                this.processes[0].img = "<img src='/images/sub/inquiry/step-1-1.png'>";
                this.processes[1].title = "택배발송";
                this.processes[1].desc = "부러진 낚싯대 / 보증서 / 접수번호 동봉하여 제이에스컴퍼니로 택배 발송해주세요. <span class='color-red'>(선불)</span>";
                this.processes[1].img = "<img src='/images/sub/inquiry/step-2-1.png'>";
            }else if(nav === 2){
                this.processes[0].title = "매장 방문";
                this.processes[0].desc = "구매점, 가까운 매장 방문하여 증상을 상세히 설명하면서 A/S 접수증을 작성해주세요.";
                this.processes[0].img = "<img src='/images/sub/inquiry/step-1-2.png'>";
                this.processes[1].title = "제품 위탁";
                this.processes[1].desc = "수리하실 제품을 맡겨주시면 방문한 매장에서 JS컴퍼니로 택배 발송해 드립니다.  ";
                this.processes[1].img = "<img src='/images/sub/inquiry/step-2-2.png'>";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
$color-primary: #ef8009;

.submission-nav{
    margin-bottom: 70px;
    &__lists { display: flex; align-items: center; justify-content: center; list-style: none; }
    &__list .link { display: block; margin: 0 30px; padding: 4px 0; font-size: 18px; color: #999999; border-bottom: 2px solid transparent; }
    &__list--on .link { color: #ef8009; border-bottom-color: #ef8009; }
}
.submission-process{
    ::v-deep img { width: auto; height: 100%; }
    &__title { margin-bottom: 50px; line-height: 1; text-align: center; font-size: 36px; }
    &__lists { display: flex; flex-wrap: wrap; list-style: none; margin: 56px -20px 80px; }
    &__list { position: relative; padding: 20px; width: 25%; }
    &__list:not(:last-child)::after { content: ''; position: absolute; top: 0; bottom: 0; right: -4px; margin: auto; width: 8px; height: 12px; background: url('/images/sub/inquiry/step-arrow.png'); }
    &__box{
        display: flex; flex-direction: column; align-items: center;
        position: relative; padding: 54px 30px 34px; height: 100%; line-height: 1.6;
        text-align: center; font-size: 18px; color: #555555;
        border: 1px solid transparentize($color-primary, .5);
        p{
            width: 100%;
        }
    }
    &__image { height: 80px; }
    &__badge{
        position: absolute; top: -16px; left: 50%;
        margin-left: -40px; padding-top: 7px; width: 80px; height: 32px; line-height: 1;
        font-style: normal; text-align: center; color: #fff;
        background: $color-primary;
    }
    &__name { margin: 36px 0 14px; line-height: 1; font-size: 24px; }
}
@media(max-width:1200px){
    .submission-nav{
        margin-bottom: 45px;
        &__list .link { margin: 0 20px; font-size: 14px; border-bottom-width: 1px; }
    }
    .submission-process{
        &__image { height: 53px; }
        &__lists { margin: 36px -7px 45px; }
        &__list { padding: 20px 7px; }
        &__title { font-size: 20px; margin-bottom: 30px; }
        &__box { font-size: 14px; padding: 36px 14px 24px; }
        &__badge { font-size: 13px; height: 28px; }
        &__name { font-size: 18px; margin: 24px 0 12px; }
    }
}
@media(max-width:768px){
    .submission-nav{
        &__lists { flex-direction: column; }
        &__list .link { margin: 5px 0; }
    }
    .submission-process{
        &__list { width: 50%; }
        &__list:not(:last-child)::after { content: none; }
    }
}
</style>
